<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { ROLE_MODULE } from '@/state/modules/role'
import { roleMethods, lookupMethods } from "@/state/helpers";

const checkFalse = (value) => value != false;

export default {
  page: {
    title: i18n.t('label.updateFormX', [i18n.t('module.role')]),
  },
  components: { Layout, PageHeader },
  beforeRouteLeave(to, from, next) {
    if (to.name != "role-listing") {
      sessionHelper.clearSearch(SESSION.ROLE_SEARCH);
    }
    next();
  },
  computed: {
    ...mapState(ROLE_MODULE, ["status"]),
    ...mapState(LOOKUP_MODULE),
    permissionDdl() {
      return this.$store.state.lookup.permissionDdl;
    },
    data() {
      return this.$store.state.role.details;
    },
  },
  data() {
    return {
      title: i18n.t('label.updateFormX', [i18n.t('module.role')]),
      items: [
        {
          text: i18n.t('module.dashboard'),
          href: "/",
        },
        {
          text: i18n.t('module.role'),
          href: "/role",
        },
        {
          text: i18n.t('label.updateX', [i18n.t('module.role')]),
          active: true,
        },
      ],
      submitted: false,
      permissions: sessionHelper.getPermissions(),
      updatePermission: null,
      readPermission: null, 
      statusDdl: ddlHelper.getActivationStatus(false, true),
    };
  },
  validations: {
    data: {
      name: { required },
      isActive: { required },
      permissions: { checkFalse },
    },
  },
  async created() {
    this.searchCriteria = sessionHelper.retrieveSearch(SESSION.ROLE_SEARCH);
    await this.validPermissions();
    this.getPermissionDdl();
    this.getRoleData();
  },
  methods: {
    ...roleMethods,
    ...lookupMethods,
    async validPermissions() {
      var jsonPermissions = JSON.parse(this.permissions)
      if (jsonPermissions.some(p => p.code === "USER_URU")) {
        this.updatePermission = true;
      }
      else {
        this.updatePermission = false;
      }

      if(jsonPermissions.some(p => p.code === "USER_URR")) {
       this.readPermission = true; 
      }
      else {
        this.readPermission = false; 
      }
    },
    getPermissionDdl() {
      this.lookupPermission({ hasOptionAll: false, });
    },
    getRoleData() {
      if (this.readPermission == true) {
        this.getRole({ id: this.searchCriteria.selectedRecordId });
      }
    },
    requestUpdate() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        let data = {
          id: this.data.uuid,
          isActive: this.data.isActive,
          permissions: this.data.permissions,
        };

        if (this.updatePermission == true) {
          this.updateRole({ data });
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="requestUpdate" v-if="readPermission == true">
              <b-form-group id="name" label-cols-sm="2" label-cols-lg="2" :label="$t('label.name')" label-for="name">
                <b-form-input for="name" v-model.trim="data.name" :class="{ 'is-invalid': !$v.data.name.required }"
                  disabled></b-form-input>
                <div v-if="!$v.data.name.required" class="invalid-feedback">
                  <span v-if="!$v.data.name.required">{{
                    $t("message.requiredX", [$t("label.name")])
                  }}</span>
                </div>
              </b-form-group>

              <div class="form-group row mb-0" style="padding-bottom: 10px">
                <label class="col-md-2 col-form-label">{{ $t('label.status') }}</label>
                <div class="col-md-10">
                  <select class="custom-select" v-model.trim="data.isActive">
                    <option v-for="status in statusDdl" :value="status.value" v-bind:key="status.value">
                      {{ status.text }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row mb-0">
                <label class="col-md-2 col-form-label">{{ $t('label.permission') }}</label>
                <div class="row">
                  <div class="col-sm-5 py-2" v-for="permission in permissionDdl" v-bind:key="permission.module">
                    <b-form-group :label="permission.module">
                      <div class="form-check" v-for="permissionData in permission.permissions"
                        v-bind:key="permissionData.code">
                        <b-form-checkbox type="checkbox" v-bind:value="permissionData.code"
                          v-bind:id="permissionData.code" v-model="data.permissions">
                          {{ permissionData.label }}
                        </b-form-checkbox>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div v-if="!$v.data.permissions.checkFalse" style="color: #ff3d60; font-size: 80%">
                  <span v-if="!$v.data.permissions.checkFalse">{{
                    $t("message.atLeastOneSelectedX", [$t("label.permission")])
                    }}</span>
                </div>
              </div>
              <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px" type="submit"
                :disabled="status.update || updatePermission != true">
                {{ $t("label.updateX", [$t('module.role')]) }}
              </button>
            </form>
            <div style="text-align: center;" v-else>
              {{ $t('message.noPermissionMessage') }}
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>